var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiProperty, ApiPropertyOptional, OmitType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from "class-validator";
import { ContactMethod } from "./consentconfig.dtos";
import { DocumentRetrievalOrigin } from "./document.retrieval.dtos";
import { TefcaProvider } from "./features.dtos";
import { NotificationAttachment, PatientLanguageSwitchUrls } from "./notification.dtos";
import { StudyTranslationLanguage } from "./study-translation-language.dtos";
import { ProjectType } from "./study.dtos";
export class PatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientDto.prototype, "id", void 0);
__decorate([
    IsString()
], PatientDto.prototype, "firstName", void 0);
__decorate([
    IsString()
], PatientDto.prototype, "lastName", void 0);
__decorate([
    IsString()
], PatientDto.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDto.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDto.prototype, "age", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], PatientDto.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientDto.prototype, "phoneVerified", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDto.prototype, "avatarUrl", void 0);
export class PatientGuidedConsentDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientGuidedConsentDto.prototype, "firstName", void 0);
__decorate([
    IsString()
], PatientGuidedConsentDto.prototype, "lastName", void 0);
__decorate([
    IsString()
], PatientGuidedConsentDto.prototype, "healthcareOrganizationId", void 0);
__decorate([
    IsString()
], PatientGuidedConsentDto.prototype, "healthExPatientId", void 0);
__decorate([
    IsString()
], PatientGuidedConsentDto.prototype, "mrn", void 0);
__decorate([
    IsString()
], PatientGuidedConsentDto.prototype, "state", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PatientGuidedConsentDto.prototype, "birthDate", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], PatientGuidedConsentDto.prototype, "lastAccessed", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientGuidedConsentDto.prototype, "language", void 0);
export class PatientGuidedConsentUpdate {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientGuidedConsentUpdate.prototype, "userId", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientGuidedConsentUpdate.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientGuidedConsentUpdate.prototype, "lastName", void 0);
__decorate([
    IsString()
], PatientGuidedConsentUpdate.prototype, "healthExPatientId", void 0);
__decorate([
    IsString()
], PatientGuidedConsentUpdate.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientGuidedConsentUpdate.prototype, "state", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    IsOptional()
], PatientGuidedConsentUpdate.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientGuidedConsentUpdate.prototype, "language", void 0);
export class PatientGuidedConsentsDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => PatientGuidedConsentDto),
    ValidateNested({ each: true })
], PatientGuidedConsentsDto.prototype, "patients", void 0);
export var PatientRequestReminderSendType;
(function (PatientRequestReminderSendType) {
    PatientRequestReminderSendType["INITIAL"] = "INITIAL";
    PatientRequestReminderSendType["AUTOMATED_REMINDER"] = "AUTOMATED_REMINDER";
    PatientRequestReminderSendType["MANUAL_REMINDER"] = "MANUAL_REMINDER";
})(PatientRequestReminderSendType || (PatientRequestReminderSendType = {}));
export class GlobalPatientReference {
}
__decorate([
    IsString()
], GlobalPatientReference.prototype, "organizationId", void 0);
__decorate([
    IsString()
], GlobalPatientReference.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], GlobalPatientReference.prototype, "mrn", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], GlobalPatientReference.prototype, "noDataAccess", void 0);
__decorate([
    IsEnum(PatientRequestReminderSendType),
    IsOptional()
], GlobalPatientReference.prototype, "patientRequestReminderSendType", void 0);
export class PatientSearchDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientSearchDto.prototype, "firstName", void 0);
__decorate([
    IsString()
], PatientSearchDto.prototype, "lastName", void 0);
__decorate([
    IsString()
], PatientSearchDto.prototype, "patientId", void 0);
__decorate([
    IsString()
], PatientSearchDto.prototype, "mrn", void 0);
__decorate([
    IsString()
], PatientSearchDto.prototype, "state", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PatientSearchDto.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientSearchDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientSearchDto.prototype, "phone", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientSearchDto.prototype, "age", void 0);
export var PatientConsentNotificationType;
(function (PatientConsentNotificationType) {
    PatientConsentNotificationType["REVOKE_PRESCREEN"] = "REVOKE_PRESCREEN";
    PatientConsentNotificationType["REVOKE_ENROLLMENT"] = "REVOKE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["AI_DATA_USE_REVOKE_ENROLLMENT"] = "AI_DATA_USE_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REVOKE_ENROLLMENT"] = "PDDE_RESEARCH_REVOKE_ENROLLMENT";
    PatientConsentNotificationType["DECLINE_PRESCREEN"] = "DECLINE_PRESCREEN";
    PatientConsentNotificationType["DECLINE_ENROLLMENT"] = "DECLINE_ENROLLMENT";
    PatientConsentNotificationType["PRESCREEN_CONFIRMATION"] = "PRESCREEN_CONFIRMATION";
    PatientConsentNotificationType["ENROLLMENT_CONFIRMATION"] = "ENROLLMENT_CONFIRMATION";
    PatientConsentNotificationType["REQUEST_PRESCREEN"] = "REQUEST_PRESCREEN";
    PatientConsentNotificationType["REMINDER_PRESCREEN"] = "REMINDER_PRESCREEN";
    PatientConsentNotificationType["DEIDENTIFIED"] = "DEIDENTIFIED";
    PatientConsentNotificationType["REQUEST_ENROLLMENT"] = "REQUEST_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REQUEST_ENROLLMENT"] = "PDDE_RESEARCH_REQUEST_ENROLLMENT";
    PatientConsentNotificationType["REMINDER_ENROLLMENT"] = "REMINDER_ENROLLMENT";
    PatientConsentNotificationType["PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT"] = "PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT";
    PatientConsentNotificationType["PDDE_RESEARCH_REMINDER_ENROLLMENT"] = "PDDE_RESEARCH_REMINDER_ENROLLMENT";
})(PatientConsentNotificationType || (PatientConsentNotificationType = {}));
export const externalResearcherSupportedPatientConsentNotificationTypes = new Set([
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REQUEST_ENROLLMENT,
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REMINDER_ENROLLMENT,
    PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT,
    PatientConsentNotificationType.PDDE_RESEARCH_REVOKE_ENROLLMENT,
]);
export function updateConsentNotificationTypeIfNeeded(notificationType, isPdda, isGeneralDataUse, isAiDataUse) {
    if (!isPdda)
        return notificationType;
    if (notificationType === PatientConsentNotificationType.REQUEST_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REQUEST_ENROLLMENT
            : PatientConsentNotificationType.PDDE_RESEARCH_REQUEST_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.REMINDER_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REMINDER_ENROLLMENT
            : PatientConsentNotificationType.PDDE_RESEARCH_REMINDER_ENROLLMENT;
    }
    else if (notificationType === PatientConsentNotificationType.REVOKE_ENROLLMENT) {
        return isGeneralDataUse
            ? PatientConsentNotificationType.PDDE_GENERAL_DATA_USE_REVOKE_ENROLLMENT
            : isAiDataUse
                ? PatientConsentNotificationType.AI_DATA_USE_REVOKE_ENROLLMENT
                : PatientConsentNotificationType.PDDE_RESEARCH_REVOKE_ENROLLMENT;
    }
    else {
        return notificationType;
    }
}
export var PatientStudyNotificationType;
(function (PatientStudyNotificationType) {
    PatientStudyNotificationType["WITHDRAWN"] = "WITHDRAWN";
    PatientStudyNotificationType["REMOVED_ENROLLED"] = "REMOVED_ENROLLED";
    PatientStudyNotificationType["RE_ADDED"] = "RE_ADDED";
    PatientStudyNotificationType["STUDY_INFORMATION"] = "STUDY_INFORMATION";
    PatientStudyNotificationType["PDDE_RESEARCH_UPDATE_RECORDS"] = "PDDE_RESEARCH_UPDATE_RECORDS";
    PatientStudyNotificationType["PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS"] = "PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS";
    PatientStudyNotificationType["PDDE_RESEARCH_RECORDS_UPDATED"] = "PDDE_RESEARCH_RECORDS_UPDATED";
})(PatientStudyNotificationType || (PatientStudyNotificationType = {}));
export const externalResearcherSupportedPatientStudyNotificationTypes = new Set([
    PatientStudyNotificationType.WITHDRAWN,
    PatientStudyNotificationType.REMOVED_ENROLLED,
    PatientStudyNotificationType.RE_ADDED,
    PatientStudyNotificationType.PDDE_RESEARCH_UPDATE_RECORDS,
    PatientStudyNotificationType.PDDE_GENERAL_DATA_USE_DATA_UPDATE_RECORDS,
    PatientStudyNotificationType.PDDE_RESEARCH_RECORDS_UPDATED,
]);
export var PatientRecordRetrievalNotificationType;
(function (PatientRecordRetrievalNotificationType) {
    PatientRecordRetrievalNotificationType["PDDE_RECORDS_FOUND_UPDATE"] = "PDDE_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["PDDE_RECORDS_FOUND_INITIAL"] = "PDDE_RECORDS_FOUND_INITIAL";
    PatientRecordRetrievalNotificationType["IAS_RECORDS_FOUND"] = "IAS_RECORDS_FOUND";
    PatientRecordRetrievalNotificationType["IAS_RECORDS_FOUND_UPDATE"] = "IAS_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_RECORDS_FOUND_INITIAL"] = "AI_DATA_USE_RECORDS_FOUND_INITIAL";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_RECORDS_FOUND_UPDATE"] = "AI_DATA_USE_RECORDS_FOUND_UPDATE";
    PatientRecordRetrievalNotificationType["AI_DATA_USE_VECTORIZATION_FAILED"] = "AI_DATA_USE_VECTORIZATION_FAILED";
})(PatientRecordRetrievalNotificationType || (PatientRecordRetrievalNotificationType = {}));
export var PatientGeneralNotificationType;
(function (PatientGeneralNotificationType) {
    PatientGeneralNotificationType["ACCOUNT_DELETION_CONFIRMATION"] = "ACCOUNT_DELETION_CONFIRMATION";
    PatientGeneralNotificationType["VERIFICATION"] = "VERIFICATION";
    PatientGeneralNotificationType["CONTACT_METHOD_CHANGED_OLD"] = "CONTACT_METHOD_CHANGED_OLD";
    PatientGeneralNotificationType["CONTACT_METHOD_CHANGED_NEW"] = "CONTACT_METHOD_CHANGED_NEW";
})(PatientGeneralNotificationType || (PatientGeneralNotificationType = {}));
export var PatientNudgeNotificationType;
(function (PatientNudgeNotificationType) {
    PatientNudgeNotificationType["CLEAR_DROPOFF"] = "CLEAR_DROPOFF";
    PatientNudgeNotificationType["DEMOGRAPHICS_DROPOFF"] = "DEMOGRAPHICS_DROPOFF";
    PatientNudgeNotificationType["CONSENT_DROPOFF"] = "CONSENT_DROPOFF";
    PatientNudgeNotificationType["RECORD_RETRIEVAL_DROPOFF"] = "RECORD_RETRIEVAL_DROPOFF";
    PatientNudgeNotificationType["NO_RECORDS_FOUND"] = "NO_RECORDS_FOUND";
    PatientNudgeNotificationType["ACCOUNT_CREATED_NO_FLOW_24H"] = "ACCOUNT_CREATED_NO_FLOW_24H";
    PatientNudgeNotificationType["ACCOUNT_CREATED_NO_FLOW_72H"] = "ACCOUNT_CREATED_NO_FLOW_72H";
})(PatientNudgeNotificationType || (PatientNudgeNotificationType = {}));
export class PatientBaseNotificationInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString({ each: true })
], PatientBaseNotificationInput.prototype, "patientIds", void 0);
__decorate([
    IsString()
], PatientBaseNotificationInput.prototype, "organizationId", void 0);
__decorate([
    IsString()
], PatientBaseNotificationInput.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientBaseNotificationInput.prototype, "organizationLogoUrl", void 0);
__decorate([
    IsOptional(),
    Type(() => NotificationAttachment)
], PatientBaseNotificationInput.prototype, "attachments", void 0);
__decorate([
    IsEnum(ContactMethod),
    IsOptional()
], PatientBaseNotificationInput.prototype, "patientContactMethod", void 0);
__decorate([
    IsEnum(StudyTranslationLanguage),
    IsOptional()
], PatientBaseNotificationInput.prototype, "patientLanguage", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientBaseNotificationInput.prototype, "phoneNumber", void 0);
__decorate([
    IsOptional(),
    IsObject()
], PatientBaseNotificationInput.prototype, "patientContactInfoOverride", void 0);
__decorate([
    IsOptional(),
    Type(() => PatientLanguageSwitchUrls)
], PatientBaseNotificationInput.prototype, "patientLanguageSwitchUrls", void 0);
export class PatientBaseNotificationWithOptionalOrganizationInput extends OmitType(PatientBaseNotificationInput, [
    "organizationId",
    "organizationName",
    "organizationLogoUrl",
]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientBaseNotificationWithOptionalOrganizationInput.prototype, "organizationLogoUrl", void 0);
export class PatientNotificationInput extends PatientBaseNotificationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientNotificationInput.prototype, "studyId", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientNotificationInput.prototype, "aiAgentName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientNotificationInput.prototype, "aiChatbotUrl", void 0);
export function toRawPatientId(patientId) {
    return typeof patientId === "object" ? patientId.identifiedPatientId : patientId;
}
export class PatientConsentNotificationInput extends OmitType(PatientNotificationInput, ["patientIds"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientConsentNotificationType)
], PatientConsentNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    IsObject({ each: true })
], PatientConsentNotificationInput.prototype, "patientIds", void 0);
export class PatientStudyNotificationInput extends PatientNotificationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientStudyNotificationType)
], PatientStudyNotificationInput.prototype, "patientNotificationType", void 0);
export class PatientRecordRetrievalNotificationInput extends OmitType(PatientNotificationInput, ["studyId"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientRecordRetrievalNotificationInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(PatientRecordRetrievalNotificationType)
], PatientRecordRetrievalNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    IsEnum(DocumentRetrievalOrigin)
], PatientRecordRetrievalNotificationInput.prototype, "documentRetrievalOrigin", void 0);
export class PatientGeneralNotificationInput extends PatientBaseNotificationWithOptionalOrganizationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientGeneralNotificationType)
], PatientGeneralNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientGeneralNotificationInput.prototype, "code", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientGeneralNotificationInput.prototype, "minutes", void 0);
export class PatientNudgeNotificationInput extends PatientBaseNotificationWithOptionalOrganizationInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientNudgeNotificationType)
], PatientNudgeNotificationInput.prototype, "patientNotificationType", void 0);
__decorate([
    IsString()
], PatientNudgeNotificationInput.prototype, "resumeUrl", void 0);
__decorate([
    IsEnum(ProjectType),
    IsOptional()
], PatientNudgeNotificationInput.prototype, "projectType", void 0);
export class RelatedPersonDto {
}
__decorate([
    IsString()
], RelatedPersonDto.prototype, "firstName", void 0);
__decorate([
    IsString()
], RelatedPersonDto.prototype, "lastName", void 0);
export class ProxyAccessDto {
}
__decorate([
    IsBoolean()
], ProxyAccessDto.prototype, "isEnabled", void 0);
__decorate([
    Type(() => RelatedPersonDto),
    ValidateNested(),
    IsOptional()
], ProxyAccessDto.prototype, "relatedPerson", void 0);
export class PatientMappingDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientMappingDto.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientMappingDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientMappingDto.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientMappingDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientMappingDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientMappingDto.prototype, "dateOfBirth", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], PatientMappingDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], PatientMappingDto.prototype, "updatedAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientMappingDto.prototype, "isSandbox", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientMappingDto.prototype, "phoneVerified", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientMappingDto.prototype, "avatarUrl", void 0);
export var PatientAccountDeletionRequestReasonType;
(function (PatientAccountDeletionRequestReasonType) {
    PatientAccountDeletionRequestReasonType["NO_LONGER_USE"] = "NO_LONGER_USE";
    PatientAccountDeletionRequestReasonType["PRIVACY_CONCERNS"] = "PRIVACY_CONCERNS";
    PatientAccountDeletionRequestReasonType["PREFER_NOT_TO_SAY"] = "PREFER_NOT_TO_SAY";
    PatientAccountDeletionRequestReasonType["OTHER"] = "OTHER";
})(PatientAccountDeletionRequestReasonType || (PatientAccountDeletionRequestReasonType = {}));
export class PatientDeleteAccountInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientAccountDeletionRequestReasonType)
], PatientDeleteAccountInput.prototype, "deletedReasonType", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDeleteAccountInput.prototype, "deletedReasonMessage", void 0);
export class CreateTestPatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "First name of the test patient. Defaults to 'Test' if not provided.",
        example: "Test",
    }),
    IsString(),
    IsOptional()
], CreateTestPatientInput.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Last name of the test patient. Defaults to 'Patient' if not provided.",
        example: "Patient",
    }),
    IsString(),
    IsOptional()
], CreateTestPatientInput.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Date of birth in ISO format (YYYY-MM-DD)",
        example: "1990-01-15",
    }),
    IsString(),
    IsOptional()
], CreateTestPatientInput.prototype, "dateOfBirth", void 0);
export class TestPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Unique identifier for the test patient",
        example: "1addc6fa-3c59-4915-b0ba-ae2a31ff1f75",
    }),
    IsString()
], TestPatientDto.prototype, "id", void 0);
__decorate([
    ApiProperty({
        description: "Auto-generated email address in format test-patient+[random]@[org-domain]",
        example: "test-patient+dqKVeMid8N41@example.com",
    }),
    IsString()
], TestPatientDto.prototype, "email", void 0);
__decorate([
    ApiProperty({
        description: "First name of the test patient",
        example: "Test",
    }),
    IsString()
], TestPatientDto.prototype, "firstName", void 0);
__decorate([
    ApiProperty({
        description: "Last name of the test patient",
        example: "Patient",
    }),
    IsString()
], TestPatientDto.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Date of birth in ISO format",
        example: "1990-01-15",
    }),
    IsString(),
    IsOptional()
], TestPatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    ApiProperty({
        description: "ID of the organization this test patient belongs to",
        example: "658ac9e4-2a8b-4775-a58f-06ef6d65d914",
    }),
    IsString()
], TestPatientDto.prototype, "organizationId", void 0);
__decorate([
    ApiProperty({
        description: "Timestamp when the test patient was created",
        example: "2026-01-31T01:52:05.653Z",
    }),
    Type(() => Date),
    IsDate()
], TestPatientDto.prototype, "createdAt", void 0);
__decorate([
    ApiProperty({
        description: "Indicates this is a test patient",
        example: true,
    }),
    IsBoolean()
], TestPatientDto.prototype, "isTestPatient", void 0);
export class TestPatientResponseDto extends TestPatientDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Auto-generated password. This is only returned once at creation time and cannot be retrieved later.",
        example: "zkWZTH$$BmfTAOW4",
    }),
    IsString()
], TestPatientResponseDto.prototype, "password", void 0);
export class UpdateTestPatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "New first name for the test patient",
        example: "TestUpdated",
    }),
    IsString(),
    IsOptional()
], UpdateTestPatientInput.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "New last name for the test patient",
        example: "PatientUpdated",
    }),
    IsString(),
    IsOptional()
], UpdateTestPatientInput.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "New date of birth in ISO format (YYYY-MM-DD)",
        example: "1990-01-15",
    }),
    IsString(),
    IsOptional()
], UpdateTestPatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Set to true to generate a new random password",
        example: true,
    }),
    IsBoolean(),
    IsOptional()
], UpdateTestPatientInput.prototype, "regeneratePassword", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Set a specific password instead of generating one",
        example: "MyCustomPassword123!",
    }),
    IsString(),
    IsOptional()
], UpdateTestPatientInput.prototype, "password", void 0);
export class UpdateTestPatientResponseDto extends TestPatientDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "New password if regeneratePassword was true or password was provided. Not included if password was not changed.",
        example: "zkWZTH$$BmfTAOW4",
    }),
    IsString(),
    IsOptional()
], UpdateTestPatientResponseDto.prototype, "password", void 0);
export var TestPatientConsentStatus;
(function (TestPatientConsentStatus) {
    TestPatientConsentStatus["OPTED_IN"] = "OPTED_IN";
    TestPatientConsentStatus["OPTED_OUT"] = "OPTED_OUT";
})(TestPatientConsentStatus || (TestPatientConsentStatus = {}));
export class UpdateTestPatientConsentInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Consent status - OPTED_IN to grant consent, OPTED_OUT to revoke consent",
        enum: TestPatientConsentStatus,
        enumName: "TestPatientConsentStatus",
        example: TestPatientConsentStatus.OPTED_IN,
    }),
    IsEnum(TestPatientConsentStatus)
], UpdateTestPatientConsentInput.prototype, "consentStatus", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Reason for revocation (only applicable when consentStatus is OPTED_OUT)",
        example: "Testing revocation flow",
    }),
    IsString(),
    IsOptional()
], UpdateTestPatientConsentInput.prototype, "revocationReason", void 0);
export class UpdateTestPatientConsentResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "ID of the consent record that was created or updated",
        example: "1addc6fa-3c59-4915-b0ba-ae2a31ff1f75",
    }),
    IsString()
], UpdateTestPatientConsentResponseDto.prototype, "consentRecordId", void 0);
export class UpdatePatientInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], UpdatePatientInput.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdatePatientInput.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdatePatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdatePatientInput.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdatePatientInput.prototype, "avatarUrl", void 0);
export class UpdatePatientTefcaProviderInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(TefcaProvider)
], UpdatePatientTefcaProviderInput.prototype, "provider", void 0);
